export default __webpack_public_path__ + "5146452cb0dc88a623748855b2b26614.png";